import { styled } from 'core'

export const Container = styled('div')`
    justify-content: start;
    cursor: pointer;
`
